<template>
  <div class="redirect-page">
    <div class="redirect-container">
      <div class="redirect-card">
        <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="redirect-icon">
          <polyline points="9 18 15 12 9 6" />
        </svg>
        <h1>Page Moved</h1>
        <p>This page has moved to <strong>UUID Generator</strong></p>
        <p class="info-text">GUID and UUID are the same thing. UUID is the official standard name.</p>
        <p class="redirect-text">Redirecting in {{ countdown }} seconds...</p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'

useHead({
  title: 'Redirecting to UUID Generator'
})

const countdown = ref(3)

onMounted(() => {
  const interval = setInterval(() => {
    countdown.value--
    if (countdown.value <= 0) {
      clearInterval(interval)
      navigateTo('/tools/uuid-generator')
    }
  }, 1000)
})
</script>

<style scoped>
.redirect-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(to bottom, #f8f9fa 0%, #ffffff 100%);
  padding: 2rem;
}

.redirect-container {
  max-width: 500px;
  width: 100%;
}

.redirect-card {
  background: white;
  border-radius: 16px;
  padding: 3rem 2rem;
  text-align: center;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
}

.redirect-icon {
  color: #667eea;
  margin-bottom: 1.5rem;
  animation: slide 1s ease-in-out infinite;
}

@keyframes slide {
  0%, 100% {
    transform: translateX(-5px);
  }
  50% {
    transform: translateX(5px);
  }
}

.redirect-card h1 {
  font-size: 2rem;
  font-weight: 700;
  color: #1a202c;
  margin-bottom: 1rem;
}

.redirect-card p {
  font-size: 1.1rem;
  color: #4a5568;
  margin-bottom: 1rem;
}

.info-text {
  font-size: 0.95rem;
  color: #718096;
  font-style: italic;
}

.redirect-text {
  font-size: 0.9rem;
  color: #a0aec0;
  margin-top: 2rem;
}

strong {
  color: #667eea;
}
</style>
